enum AppNameEnum {
	BANKERA = 'Bankera',
	SPECTROCOIN = 'SpectroCoin',
	AUTOKYC = 'AutoKYC'
}

export default AppNameEnum;
